import { STEP } from '../@types/state'
import { ProgressType } from '../@types/progress'
import { WizardFlowType } from '../@types/wizardFlowType'

const rleProgressMap: ProgressType = {
  [STEP.LOCATION]: { previous: 10, current: 23, next: 39 },
  [STEP.AREA]: { previous: 23, current: 39, next: 52 },
  [STEP.ROOMS]: { previous: 39, current: 52, next: 65 },
  [STEP.INTENT]: { previous: 52, current: 60, next: 63 },
  [STEP.RENT_OUT_INTENT]: { previous: 60, current: 63, next: 72 },
  [STEP.RENT_OUT_REINFORCEMENT]: { previous: 63, current: 72, next: 74 },
  [STEP.RADIUS]: { previous: 65, current: 72, next: 78 },
  [STEP.EQUITY]: { previous: 72, current: 78, next: 83 },
  [STEP.INCOME]: { previous: 78, current: 83, next: 88 },
  [STEP.EMPLOYMENT]: { previous: 83, current: 88, next: 92 },
  [STEP.TIME_HORIZON]: { previous: 88, current: 92, next: 96 },
  [STEP.OWNER]: { previous: 92, current: 96, next: 100 },
  [STEP.CONTACT]: { previous: 96, current: 100, next: 100 },
}

const ibwProgressMap: ProgressType = {
  [STEP.LOCATION]: { previous: 10, current: 19, next: 30 },
  [STEP.AREA]: { previous: 19, current: 30, next: 41 },
  [STEP.ROOMS]: { previous: 30, current: 41, next: 52 },
  [STEP.INTENT]: { previous: 41, current: 52, next: 63 },
  [STEP.SELL_INTENT]: { previous: 52, current: 63, next: 74 },
  [STEP.RENT_OUT_INTENT]: { previous: 52, current: 63, next: 74 },
  [STEP.RENT_OUT_REINFORCEMENT]: { previous: 63, current: 74, next: 76 },
  [STEP.REINFORCEMENT]: { previous: 74, current: 76, next: 78 },
  [STEP.RADIUS]: { previous: 76, current: 78, next: 80 },
  [STEP.EQUITY]: { previous: 78, current: 80, next: 82 },
  [STEP.INCOME]: { previous: 80, current: 82, next: 84 },
  [STEP.EMPLOYMENT]: { previous: 82, current: 84, next: 90 },
  [STEP.TIME_HORIZON]: { previous: 84, current: 90, next: 94 },
  [STEP.OWNER]: { previous: 90, current: 94, next: 98 },
  [STEP.PARTIAL_SALE]: { previous: 94, current: 98, next: 100 },
  [STEP.CONTACT]: { previous: 98, current: 100, next: 100 },
}

const defaultSolarProgress: ProgressType = {
  [STEP.PLACEMENT_TYPE]: { previous: 10, current: 23, next: 39 },
  [STEP.LOCATION]: { previous: 23, current: 39, next: 52 },
  [STEP.SOLAR_INTENT]: { previous: 39, current: 52, next: 65 },
  [STEP.TIME_HORIZON]: { previous: 52, current: 65, next: 78 },
  [STEP.PLEASE_WAIT]: { previous: 65, current: 78, next: 100 },
  [STEP.CONTACT]: { previous: 78, current: 100, next: 100 },
  [STEP.RESPONSE]: { previous: 78, current: 100, next: 100 },
}

const progressMap: { [k in WizardFlowType]: ProgressType } = {
  [WizardFlowType.RLE]: rleProgressMap,
  [WizardFlowType.IBW]: ibwProgressMap,
  [WizardFlowType.SOLAR]: defaultSolarProgress,
}

export { progressMap }
